import * as React from 'react';
import { colors } from '../../../index';

const IconNetwork = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 33 32",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.334 10.55a6.86 6.86 0 00-1.027 1.093L9.302 9.748a2.957 2.957 0 01-1.574.459 2.978 2.978 0 112.977-2.978c0 .519-.144 1-.378 1.425l2.007 1.897zm8.491-.236a6.661 6.661 0 00-1.285-.769l2.658-4.476A2.975 2.975 0 0124.313 0a2.976 2.976 0 110 5.955c-.285 0-.558-.054-.82-.13l-2.668 4.49zm9.2 3.757a2.975 2.975 0 110 5.952 2.972 2.972 0 01-2.933-2.51l-3.705-.366c.096-.456.15-.928.15-1.41 0-.028-.004-.055-.004-.083l3.705.366a2.974 2.974 0 012.786-1.949zM19.797 25.777a2.97 2.97 0 012.886 2.969 2.974 2.974 0 01-2.975 2.975 2.974 2.974 0 01-2.98-2.975c0-1.149.657-2.133 1.608-2.63l-.83-3.621a6.784 6.784 0 001.462-.338l.829 3.62zm-9.718-8.604c.108.497.274.97.482 1.42l-4.628 1.55c.006.068.02.13.02.2a2.978 2.978 0 11-2.978-2.977c1.043 0 1.96.54 2.491 1.353l4.613-1.546zm6.652 3.668a5.105 5.105 0 110-10.21 5.105 5.105 0 010 10.21z"
  }));
};

export default IconNetwork;